import React from 'react';
import YearFilter from './YearFilter';
import SearchFilter from './SearchFilter';

function AppFilters() {
    return (
        <fieldset className="filter-group">
            <legend className="filter-title">Show Results From</legend>
            <YearFilter />
            <SearchFilter />
        </fieldset>
    );
}

export default AppFilters;
